import config from '../constants/config';

export const checkFeatureEnabled = (feature: string): boolean => {
  return config.ENABLED_FEATURES.has(feature);
};
